module.exports = "* {\n  color: #b0b0b0;\n  line-height: 105%; }\n\n.message {\n  height: 100vh;\n  background-color: #282b31; }\n\n.orbit-editor-error {\n  font-size: 16rem; }\n\np {\n  font-size: 2.75rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error/error.component.scss
// module id = ./src/app/components/error/error.component.scss
// module chunks = main